const loaderBackgroundColor = '#ece7ec'
const loaderColor = '#ff4702'

export {
  loaderBackgroundColor,
  loaderColor,
}
